import PropTypes from 'prop-types';
import React from 'react';
import { CSSTransition } from 'react-transition-group';

import Alert, { TYPES } from 'components/Alert';
import Theme from 'styles/theme';

const ANIMATION = {
  DURATION_ENTER: 200,
  DURATION_LEAVE: 100,
  HEIGHT_COLLAPSED: 0,
  HEIGHT_EXPANDED: 54, // equivalent of three lines of text
};

const CartAlert = ({ message }) => (
  <div className="CartAlert">
    <CSSTransition classNames="CartAlert__expand-transition" timeout={ANIMATION.DURATION_ENTER}>
      {message && <Alert message={message} type={TYPES.WARNING} />}
    </CSSTransition>
    <style jsx>
      {`
        .CartAlert {
          text-align: center;
          padding: 12px;
        }
      `}
    </style>
    <style jsx global>
      {`
        .CartAlert__expand-transition {
          max-height: ${ANIMATION.HEIGHT_COLLAPSED}px;
        }

        .CartAlert__expand-transition.CartAlert__expand-transition-active {
          max-height: ${ANIMATION.HEIGHT_EXPANDED}px;
          transition: max-height ${ANIMATION.DURATION_ENTER}ms
            ${Theme.get('transition-timing-ease-out-quad')};
        }
      `}
    </style>
  </div>
);

CartAlert.propTypes = {
  message: PropTypes.string,
};

CartAlert.defaultProps = {
  message: null,
};

export default CartAlert;
